import { render, staticRenderFns } from "./TeethChart.vue?vue&type=template&id=aba020a2&scoped=true&"
import script from "./TeethChart.vue?vue&type=script&lang=js&"
export * from "./TeethChart.vue?vue&type=script&lang=js&"
import style0 from "./TeethChart.vue?vue&type=style&index=0&id=aba020a2&scoped=true&lang=css&"
import style1 from "./TeethChart.vue?vue&type=style&index=1&id=aba020a2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba020a2",
  null
  
)

export default component.exports